import { Aesdecryption } from "./Aes/Aes"
import Urlencoder from "./Urluncoder"

export const decodeUrl = (data) => {
console.log(data,"data")
const splitData=data.split('?')
if(splitData.length < 2) return;
            if (data.split('?')[1] !== "") {
                console.log(data)
                let enctext = data.split('?')[1]
                try {
                    let AesDec = Aesdecryption(enctext)
                    return Urlencoder(data.split('?')[0] + '/' + btoa(AesDec))
                }catch(err){
                    let dectext = `?${enctext}`
                    return Urlencoder(data.split('?')[0]+'/'+dectext)
                }
                
            } else {
                return Urlencoder(data)
            }
        }